// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.mobile_mm .menu-primary-navigation-container{overflow-y:scroll}.bot_nav_wrap .menu-primary-navigation-container .menu-item.menu-has-depth-2 .sub-menu .sub-menu,.bot_nav_wrap .menu-primary-navigation-container .menu-item:not(.menu-has-depth-2) .sub-menu{overflow:auto;max-height:600px}.header_mid-buttons{margin-top:-10px;padding:9px 20px 9px 30px}", ""]);
// Exports
module.exports = exports;
